<ng-container *ngIf="category$ | async as items">
  <div class="container js-special-offer">
    <label [ngClass]="activeLanguage$ | async">{{ title$ | async }}</label>
    <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" *ngIf="items.length > 0" [config]="slickConfig">
      <div ngxSlickItem *ngFor="let data of items" class="slide">
        <!-- ADDED div for SMARTEDIT CAROUSEL (DO NOT REMOVE)-->
        <div>
          <div class="item">
            <div class="cat-name" *ngIf="(data.title | json) != '{}'">{{ data.title }}</div>
            <div class="cat-desc" *ngIf="(data.description | json) != '{}'">{{ data.description }}</div>
            <div class="cat-bottom">
              <cx-media [container]="data.media" [class.is-missing-fish]="businessType === 'fish'"></cx-media>
              <a
                tabindex="0"
                [routerLink]="getLink(data)"
                [queryParams]="getQueryParams(data?.url)"
                (click)="gtmClickPromotion(data)"
                >{{ 'productCarousel.goToPromotion' | cxTranslate }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </ngx-slick-carousel>
  </div>
</ng-container>
